import React, { useEffect, useState, createContext, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Product, Order, Category, OrderStatus, CustomOrderRequest } from '../types/models';
// Seed Data
const SEED_CATEGORIES: Category[] = [{
  id: 'cat-1',
  title: 'Custom Balloons',
  description: 'Floating joy for every occasion, personalized with your message.',
  image: 'https://cdn.magicpatterns.com/uploads/27Mx1AbDkr24gNPNEm7K7U/R_(3).jpg',
  color: 'from-rose-500/80 to-rose-900/80'
}, {
  id: 'cat-2',
  title: 'Gift Boxes',
  description: 'Curated collections of treats and treasures, beautifully wrapped.',
  image: 'https://cdn.magicpatterns.com/uploads/nK4NPPRs6gXWSuUU5PYpCz/20220207_110730-scaled.jpg',
  color: 'from-purple-500/80 to-purple-900/80'
}, {
  id: 'cat-3',
  title: 'Fresh Flowers',
  description: 'Seasonal blooms arranged to perfection and delivered fresh.',
  image: 'https://cdn.magicpatterns.com/uploads/g4wvfJbAy29XT9uTzbmhYP/678a4c8333e128b4a59185410a4a6317.jpg',
  color: 'from-emerald-500/80 to-emerald-900/80'
}];
const SEED_PRODUCTS: Product[] = [{
  id: 'prod-1',
  name: 'Birthday Celebration Box',
  price: 350,
  category: 'Gift Boxes',
  image: 'https://cdn.magicpatterns.com/uploads/nK4NPPRs6gXWSuUU5PYpCz/20220207_110730-scaled.jpg',
  stock: 999,
  isNew: true
}, {
  id: 'prod-2',
  name: 'Romantic Rose Box',
  price: 400,
  category: 'Fresh Flowers',
  image: 'https://cdn.magicpatterns.com/uploads/g4wvfJbAy29XT9uTzbmhYP/678a4c8333e128b4a59185410a4a6317.jpg',
  stock: 999,
  isNew: true
}, {
  id: 'prod-3',
  name: 'Deluxe Spa Gift Box',
  price: 350,
  category: 'Gift Boxes',
  image: 'https://cdn.magicpatterns.com/uploads/6dsPw5GgJ3V5KCj9ERhNbL/2058a4df6a99f80acc98296ac4c55ac8.jpg',
  stock: 999,
  description: 'Starts from R350'
}, {
  id: 'prod-4',
  name: 'Lavender Garden Bouquet',
  price: 400,
  category: 'Fresh Flowers',
  image: 'https://cdn.magicpatterns.com/uploads/j2stBjcwKdk5PrJb58f4aY/9a004d123c041c53650c30f5b6096eca.jpg',
  stock: 999,
  isNew: true
}, {
  id: 'prod-5',
  name: 'Mummy To Be Gift Set',
  price: 250,
  category: 'Gift Boxes',
  image: 'https://cdn.magicpatterns.com/uploads/ncZZZHYyeE6QJBbUXC8HwY/0c9e5cb8245286c06f035152cf25b89d.jpg',
  stock: 999
}, {
  id: 'prod-6',
  name: 'Classic Rose Arrangement',
  price: 400,
  category: 'Fresh Flowers',
  image: 'https://cdn.magicpatterns.com/uploads/dXHPEt7Yw3pMAP9rY1R5yH/85771c431d647833304aa1099abe2f92.jpg',
  stock: 999
}, {
  id: 'prod-7',
  name: 'Personalized Birthday Balloon',
  price: 200,
  category: 'Custom Balloons',
  image: 'https://cdn.magicpatterns.com/uploads/27Mx1AbDkr24gNPNEm7K7U/R_(3).jpg',
  stock: 999
}, {
  id: 'prod-8',
  name: 'Milestone Celebration Balloon',
  price: 200,
  category: 'Custom Balloons',
  image: 'https://cdn.magicpatterns.com/uploads/bidiWptJqMDVMkPoktskPx/9b22454353ad10c0c0abd71c679c4fa0.jpg',
  stock: 999
}, {
  id: 'prod-9',
  name: 'Jumah Mubarak Balloon',
  price: 500,
  category: 'Custom Balloons',
  image: 'https://cdn.magicpatterns.com/uploads/fvUdrwMEJHQqtNgup9mKZp/7729723db33f7e95fe6ff658ebe9ad87.jpg',
  stock: 999,
  description: 'Starts from R500'
}, {
  id: 'prod-10',
  name: 'Welcome Baby Boy Set',
  price: 500,
  category: 'Custom Balloons',
  image: 'https://cdn.magicpatterns.com/uploads/kt8QTDTbSkcFXKUnmKwZTA/3b153ec169318c392d15a5a952ea7f41.jpg',
  stock: 999,
  description: 'Starts from R500'
}, {
  id: 'prod-11',
  name: "Men's Grooming Gift Basket",
  price: 450,
  category: 'Gift Boxes',
  image: 'https://cdn.magicpatterns.com/uploads/sYGKmYRBf5kyptrKc9NBLj/223b02b747605baaa64b02a5e627618c.jpg',
  stock: 999,
  description: 'Starts from R450'
}, {
  id: 'prod-12',
  name: 'Custom Party Balloon',
  price: 200,
  category: 'Custom Balloons',
  image: 'https://cdn.magicpatterns.com/uploads/27Mx1AbDkr24gNPNEm7K7U/R_(3).jpg',
  stock: 999,
  description: 'Starts from R200'
}];
// No seed orders - orders will only come from actual user checkouts
const SEED_ORDERS: Order[] = [];
interface DataContextType {
  products: Product[];
  orders: Order[];
  categories: Category[];
  customOrderRequests: CustomOrderRequest[];
  addProduct: (product: Omit<Product, 'id'>) => void;
  updateProduct: (id: string, product: Partial<Product>) => void;
  deleteProduct: (id: string) => void;
  addOrder: (order: Omit<Order, 'id'>) => void;
  updateOrderStatus: (id: string, status: OrderStatus) => void;
  addCategory: (category: Omit<Category, 'id'>) => void;
  deleteCategory: (id: string) => void;
  addCustomOrderRequest: (request: Omit<CustomOrderRequest, 'id' | 'createdAt'>) => void;
  updateCustomOrderRequest: (id: string, updates: Partial<CustomOrderRequest>) => void;
  deleteCustomOrderRequest: (id: string) => void;
  convertCustomOrderToRegularOrder: (customOrderId: string, status: OrderStatus) => void;
}
const DataContext = createContext<DataContextType | undefined>(undefined);
export function DataProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [products, setProducts] = useState<Product[]>([]);
  const [orders, setOrders] = useState<Order[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [customOrderRequests, setCustomOrderRequests] = useState<CustomOrderRequest[]>([]);
  useEffect(() => {
    // Load or seed data
    const storedProducts = localStorage.getItem('bloom-pop-products');
    if (storedProducts) {
      setProducts(JSON.parse(storedProducts));
    } else {
      setProducts(SEED_PRODUCTS);
      localStorage.setItem('bloom-pop-products', JSON.stringify(SEED_PRODUCTS));
    }
    const storedOrders = localStorage.getItem('bloom-pop-orders');
    if (storedOrders) {
      setOrders(JSON.parse(storedOrders));
    } else {
      // Start with empty orders - only real user orders will appear
      setOrders(SEED_ORDERS);
      localStorage.setItem('bloom-pop-orders', JSON.stringify(SEED_ORDERS));
    }
    const storedCategories = localStorage.getItem('bloom-pop-categories');
    if (storedCategories) {
      setCategories(JSON.parse(storedCategories));
    } else {
      setCategories(SEED_CATEGORIES);
      localStorage.setItem('bloom-pop-categories', JSON.stringify(SEED_CATEGORIES));
    }
    const storedCustomOrders = localStorage.getItem('bloom-pop-custom-orders');
    if (storedCustomOrders) {
      setCustomOrderRequests(JSON.parse(storedCustomOrders));
    } else {
      setCustomOrderRequests([]);
      localStorage.setItem('bloom-pop-custom-orders', JSON.stringify([]));
    }
  }, []);
  // Auto-delete completed orders after 8 hours
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const EIGHT_HOURS = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
      const filteredOrders = orders.filter(order => {
        // Only check orders that are Delivered or Collected
        if (order.status === 'Delivered' || order.status === 'Collected') {
          if (order.completedAt) {
            const completedTime = new Date(order.completedAt).getTime();
            const timePassed = now - completedTime;
            // If 8 hours have passed, remove the order
            return timePassed < EIGHT_HOURS;
          }
        }
        // Keep all other orders
        return true;
      });
      // Only update if orders were actually removed
      if (filteredOrders.length !== orders.length) {
        saveOrders(filteredOrders);
      }
    }, 60000); // Check every minute
    return () => clearInterval(interval);
  }, [orders]);
  // Auto-remove special event flag when end date passes
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      now.setHours(0, 0, 0, 0); // Reset to start of day for date comparison
      let hasChanges = false;
      const updatedProducts = products.map(product => {
        if (product.isSpecialEvent && product.specialEventEndDate) {
          const endDate = new Date(product.specialEventEndDate);
          endDate.setHours(23, 59, 59, 999); // End of the end date
          // If current date is past the end date, remove special event status
          if (now > endDate) {
            hasChanges = true;
            return {
              ...product,
              isSpecialEvent: false,
              specialEventStartDate: undefined,
              specialEventEndDate: undefined
            };
          }
        }
        return product;
      });
      // Only update if products were actually modified
      if (hasChanges) {
        saveProducts(updatedProducts);
      }
    }, 3600000); // Check every hour
    return () => clearInterval(interval);
  }, [products]);
  const saveProducts = (newProducts: Product[]) => {
    setProducts(newProducts);
    localStorage.setItem('bloom-pop-products', JSON.stringify(newProducts));
  };
  const saveOrders = (newOrders: Order[]) => {
    setOrders(newOrders);
    localStorage.setItem('bloom-pop-orders', JSON.stringify(newOrders));
  };
  const saveCategories = (newCategories: Category[]) => {
    setCategories(newCategories);
    localStorage.setItem('bloom-pop-categories', JSON.stringify(newCategories));
  };
  const saveCustomOrderRequests = (newRequests: CustomOrderRequest[]) => {
    setCustomOrderRequests(newRequests);
    localStorage.setItem('bloom-pop-custom-orders', JSON.stringify(newRequests));
  };
  const addProduct = (product: Omit<Product, 'id'>) => {
    const newProduct = {
      ...product,
      id: uuidv4()
    };
    saveProducts([...products, newProduct]);
  };
  const updateProduct = (id: string, updates: Partial<Product>) => {
    const updatedProducts = products.map(p => p.id === id ? {
      ...p,
      ...updates
    } : p);
    saveProducts(updatedProducts);
  };
  const deleteProduct = (id: string) => {
    saveProducts(products.filter(p => p.id !== id));
  };
  const addOrder = (order: Omit<Order, 'id'>) => {
    const newOrder = {
      ...order,
      id: `ORD-${Math.random().toString(36).substr(2, 9).toUpperCase()}`
    };
    saveOrders([newOrder, ...orders]);
  };
  const updateOrderStatus = (id: string, status: OrderStatus) => {
    const updatedOrders = orders.map(o => {
      if (o.id === id) {
        const updates: Partial<Order> = {
          status
        };
        // If status is being changed to Delivered or Collected, set completedAt timestamp
        if ((status === 'Delivered' || status === 'Collected') && !o.completedAt) {
          updates.completedAt = new Date().toISOString();
        }
        return {
          ...o,
          ...updates
        };
      }
      return o;
    });
    saveOrders(updatedOrders);
  };
  const addCategory = (category: Omit<Category, 'id'>) => {
    const newCategory = {
      ...category,
      id: uuidv4()
    };
    saveCategories([...categories, newCategory]);
  };
  const deleteCategory = (id: string) => {
    saveCategories(categories.filter(c => c.id !== id));
  };
  const addCustomOrderRequest = (request: Omit<CustomOrderRequest, 'id' | 'createdAt'>) => {
    const newRequest: CustomOrderRequest = {
      ...request,
      id: `CUSTOM-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
      createdAt: new Date().toISOString()
    };
    saveCustomOrderRequests([newRequest, ...customOrderRequests]);
  };
  const updateCustomOrderRequest = (id: string, updates: Partial<CustomOrderRequest>) => {
    const updatedRequests = customOrderRequests.map(r => r.id === id ? {
      ...r,
      ...updates
    } : r);
    saveCustomOrderRequests(updatedRequests);
  };
  const deleteCustomOrderRequest = (id: string) => {
    saveCustomOrderRequests(customOrderRequests.filter(r => r.id !== id));
  };
  const convertCustomOrderToRegularOrder = (customOrderId: string, status: OrderStatus) => {
    // Find the custom order request
    const customOrder = customOrderRequests.find(r => r.id === customOrderId);
    if (!customOrder) return;
    // Create a regular order from the custom order
    const newOrder: Order = {
      id: customOrderId,
      userId: customOrder.userId,
      customerName: customOrder.customerName,
      customerEmail: customOrder.customerEmail,
      customerPhone: customOrder.customerPhone,
      deliveryAddress: '',
      deliveryType: 'delivery',
      deliveryDate: new Date().toISOString(),
      preferredTime: 'Anytime',
      deliveryFee: 0,
      items: [{
        productId: 'custom',
        quantity: 1,
        price: customOrder.quotedPrice || 0,
        name: `Custom ${customOrder.category.charAt(0).toUpperCase() + customOrder.category.slice(1)}`,
        customMessage: customOrder.customizationDetails
      }],
      total: customOrder.quotedPrice || 0,
      status: status,
      date: customOrder.createdAt,
      isCustomOrder: true
    };
    // Add to regular orders
    saveOrders([newOrder, ...orders]);
    // Update custom order status to 'accepted'
    updateCustomOrderRequest(customOrderId, {
      status: 'accepted'
    });
  };
  return <DataContext.Provider value={{
    products,
    orders,
    categories,
    customOrderRequests,
    addProduct,
    updateProduct,
    deleteProduct,
    addOrder,
    updateOrderStatus,
    addCategory,
    deleteCategory,
    addCustomOrderRequest,
    updateCustomOrderRequest,
    deleteCustomOrderRequest,
    convertCustomOrderToRegularOrder
  }} data-id="element-1190">
      {children}
    </DataContext.Provider>;
}
export function useData() {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
}